import {
  faGear,
  faPalette,
  faChartMixed,
  faTag,
  faListCheck,
  faPenClip,
  faUsers,
  faCopy,
  faLockKeyhole,
  faTrashCan,
  faCloud,
  faPlay,
} from '@fortawesome/pro-light-svg-icons';
import {
  faGear as faGearRegular,
  faPalette as faPaletteRegular,
  faChartMixed as faChartMixedRegular,
  faTag as faTagRegular,
  faListCheck as faListCheckRegular,
  faPenClip as faPenClipRegular,
  faUsers as faUsersRegular,
  faCopy as faCopyRegular,
  faLockKeyhole as faLockKeyholeRegular,
  faTrashCan as faTrashCanRegular,
  faCloud as faCloudRegular,
  faPlay as faPlayRegular,
} from '@fortawesome/pro-regular-svg-icons';

import { ManageRoomDetail, ManageRoomNavigationTab } from '../../manage-room.types';
import { GeneralSettings } from '../general-settings';
import { DesignTab } from '../design-tab';
import { VideoTab } from '../video-tab';
import { WriteUps } from '../write-ups/write-ups';
import { CategoriesTab } from '../categories-tab';
import { TasksTab } from '../tasks-tab';
import { UsersTab } from '../users-tab';
import { StatsTab } from '../stats-tab';
import { AccessTab } from '../access-tab';
import { DeleteTab } from '../delete-tab';
import { CloneTab } from '../clone-tab';
import { CloudIntegrationTab } from '../cloud-integration-tab/cloud-integration-tab';

export const cloudIntegrationTab: ManageRoomNavigationTab = {
  key: 'cloud-integration',
  name: 'Cloud Integration',
  icon: faCloud,
  selectedIcon: faCloudRegular,
};

export const manageRoomTabs: ManageRoomNavigationTab[] = [
  {
    key: 'general-settings',
    name: 'General Settings',
    icon: faGear,
    selectedIcon: faGearRegular,
  },
  {
    key: 'design',
    name: 'Design',
    icon: faPalette,
    selectedIcon: faPaletteRegular,
  },
  {
    key: 'video',
    name: 'Video',
    icon: faPlay,
    selectedIcon: faPlayRegular,
  },
  {
    key: 'stats',
    name: 'Stats',
    icon: faChartMixed,
    selectedIcon: faChartMixedRegular,
  },
  {
    key: 'categories',
    name: 'Categories',
    icon: faTag,
    selectedIcon: faTagRegular,
  },
  {
    key: 'tasks',
    name: 'Tasks',
    icon: faListCheck,
    selectedIcon: faListCheckRegular,
  },
  {
    key: 'write-ups',
    name: 'Write-ups',
    icon: faPenClip,
    selectedIcon: faPenClipRegular,
  },
  {
    key: 'users',
    name: 'Users',
    icon: faUsers,
    selectedIcon: faUsersRegular,
  },
  {
    key: 'clone',
    name: 'Clone',
    icon: faCopy,
    selectedIcon: faCopyRegular,
  },
  {
    key: 'access',
    name: 'Access',
    icon: faLockKeyhole,
    selectedIcon: faLockKeyholeRegular,
  },
  {
    key: 'delete',
    name: 'Delete',
    icon: faTrashCan,
    selectedIcon: faTrashCanRegular,
  },
];

export const navigationTabComponents: {
  [key: string]: ({
    roomDetails,
    isContentDev,
  }: {
    roomDetails: ManageRoomDetail;
    isContentDev: boolean;
  }) => JSX.Element;
} = {
  'general-settings': GeneralSettings,
  'cloud-integration': CloudIntegrationTab,
  design: DesignTab,
  video: VideoTab,
  'write-ups': WriteUps,
  categories: CategoriesTab,
  tasks: TasksTab,
  users: UsersTab,
  stats: StatsTab,
  access: AccessTab,
  delete: DeleteTab,
  clone: CloneTab,
};
